import SceneManagementRoutes from './routes'
import 'windi.css'

export default {
  // name version 必须为字面常量
  name: 'scene-management',
  title: '场景管理',
  version: '0.1.20',
  description: '场景管理',
  routes: SceneManagementRoutes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: ['ModelMenuApi', 'ModelSceneApi', 'FileApi'],
  },
}
